/**
 * Service Controller — Workspace "Công việc hôm nay"
 * Contract: TimesschoolsLA/ba-shared/api-contracts/task/task-workspace.md (v2.0)
 * Quyền: TSK0. Khối đơn duyệt/email server tự lọc theo quyền (TKA/EM0) hoặc theo dữ liệu
 * (người duyệt = tôi) — không quyền trả khối RỖNG, KHÔNG lỗi.
 */

import { request } from '../../utils/apiUtils';
import { URL_API } from '../../url.config';

const BASE_URL = `${URL_API}/api/sas-school/workspace`;

const WorkspaceController = {
    /** Màn "Hôm nay": bucket task + đơn chờ duyệt + email chưa đọc */
    today: (callback) => {
        return request({ url: `${BASE_URL}/today`, method: 'GET' }, callback);
    },

    /** Badge đếm gọn cho menu: { taskCount, approvalCount, emailUnreadCount, total } */
    badge: (callback) => {
        return request({ url: `${BASE_URL}/badge`, method: 'GET' }, callback);
    },

    /**
     * SCR-137 · contract v2.0 §9b — đơn chờ TÔI duyệt, nắn về hình dạng thẻ việc cho tab "Bảng".
     * data = { timeBucket?, types?, keyword? } (gửi {} = lấy tất cả).
     * → { items: ApprovalCardRes[], total, truncated }. KHÔNG phân trang: server cắt trần 200
     * rồi bật cờ `truncated` — chạm trần thì dẫn người dùng sang màn duyệt, đừng gọi lại.
     * Thẻ trả về CHỈ ĐỌC: không kéo thả, không gọi /task/status hay /task/board/reorder được.
     */
    approvals: (data, callback) => {
        return request({ url: `${BASE_URL}/approvals`, method: 'POST', data: data || {} }, callback);
    },
};

export default WorkspaceController;
